import { Model, SpraypaintBase } from 'spraypaint';

@Model()
export class ApplicationRecord extends SpraypaintBase {
  static baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  static apiNamespace = process.env.REACT_APP_API_NAMESPACE || '';
}
